import React from "react";
import KPICard, { type KPICardProps } from "./KPICard";

type HighFindingsKPIProps = Omit<KPICardProps, "groupBy" | "severity">;

const HighFindingsKPI: React.FC<HighFindingsKPIProps> = ({
  selectedScope,
  filterToExecute,
  scopeToExecute,
  widgetKey,
  setIsReadyToExport = null,
}) => {
  return (
    <KPICard
      selectedScope={selectedScope}
      filterToExecute={filterToExecute}
      scopeToExecute={scopeToExecute}
      groupBy={["finding.severity"]}
      severity={2}
      widgetKey={widgetKey}
      setIsReadyToExport={setIsReadyToExport}
    />
  );
};

export default HighFindingsKPI;
